<template>
    <div
        :class="{
            'radio-simple': true,
            'radio-simple--checked': checked,
        }"
        @click="onClick">
        <Icon
            :type="checked ? 'radio_checked_dark' : 'radio'"
            class="mr-2 radio-simple__checkbox" />
        <span>
            {{ text }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'RadioSimple',
    props: {
        checked: { type: Boolean, required: true },
        text: { type: String, required: true },
    },
    methods: {
        onClick () {
            this.$emit('click');
        },
    },
};
</script>

<style scoped lang="scss">
.radio-simple {
  padding: 10px 5px;
  margin-bottom: 5px;
  background: $mb-grey-12;
}

.radio-simple__checkbox {
  vertical-align: middle;
}
</style>
